import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { delay } from "../util/helpers.js";
import { createClientLogger } from "@azure/logger";
import { AbortError } from "@azure/abort-controller";
import { DEFAULT_RETRY_POLICY_COUNT } from "../constants.js";
var retryPolicyLogger = createClientLogger("core-rest-pipeline retryPolicy");
/**
 * The programmatic identifier of the retryPolicy.
 */

var retryPolicyName = "retryPolicy";
/**
 * retryPolicy is a generic policy to enable retrying requests when certain conditions are met
 */

export function retryPolicy(strategies) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    maxRetries: DEFAULT_RETRY_POLICY_COUNT
  };
  var logger = options.logger || retryPolicyLogger;
  return {
    name: retryPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        var _a, _b, response, responseError, retryCount, abortError, _iterator, _step, strategy, strategyLogger, modifiers, errorToThrow, retryAfterInMs, redirectTo;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                retryCount = -1; // eslint-disable-next-line no-constant-condition

              case 1:
                if (!true) {
                  _context.next = 78;
                  break;
                }

                retryCount += 1;
                response = undefined;
                responseError = undefined;
                _context.prev = 5;
                logger.info("Retry ".concat(retryCount, ": Attempting to send request"), request.requestId);
                _context.next = 9;
                return next(request);

              case 9:
                response = _context.sent;
                logger.info("Retry ".concat(retryCount, ": Received a response from request"), request.requestId);
                _context.next = 20;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](5);
                logger.error("Retry ".concat(retryCount, ": Received an error from request"), request.requestId); // RestErrors are valid targets for the retry strategies.
                // If none of the retry strategies can work with them, they will be thrown later in this policy.
                // If the received error is not a RestError, it is immediately thrown.

                responseError = _context.t0;

                if (!(!_context.t0 || responseError.name !== "RestError")) {
                  _context.next = 19;
                  break;
                }

                throw _context.t0;

              case 19:
                response = responseError.response;

              case 20:
                if (!((_a = request.abortSignal) === null || _a === void 0 ? void 0 : _a.aborted)) {
                  _context.next = 24;
                  break;
                }

                logger.error("Retry ".concat(retryCount, ": Request aborted."));
                abortError = new AbortError();
                throw abortError;

              case 24:
                if (!(retryCount >= ((_b = options.maxRetries) !== null && _b !== void 0 ? _b : DEFAULT_RETRY_POLICY_COUNT))) {
                  _context.next = 35;
                  break;
                }

                logger.info("Retry ".concat(retryCount, ": Maximum retries reached. Returning the last received response, or throwing the last received error."));

                if (!responseError) {
                  _context.next = 30;
                  break;
                }

                throw responseError;

              case 30:
                if (!response) {
                  _context.next = 34;
                  break;
                }

                return _context.abrupt("return", response);

              case 34:
                throw new Error("Maximum retries reached with no response or error to throw");

              case 35:
                logger.info("Retry ".concat(retryCount, ": Processing ").concat(strategies.length, " retry strategies."));
                _iterator = _createForOfIteratorHelper(strategies);
                _context.prev = 37;

                _iterator.s();

              case 39:
                if ((_step = _iterator.n()).done) {
                  _context.next = 62;
                  break;
                }

                strategy = _step.value;
                strategyLogger = strategy.logger || retryPolicyLogger;
                strategyLogger.info("Retry ".concat(retryCount, ": Processing retry strategy ").concat(strategy.name, "."));
                modifiers = strategy.retry({
                  retryCount: retryCount,
                  response: response,
                  responseError: responseError
                });

                if (!modifiers.skipStrategy) {
                  _context.next = 47;
                  break;
                }

                strategyLogger.info("Retry ".concat(retryCount, ": Skipped."));
                return _context.abrupt("continue", 60);

              case 47:
                errorToThrow = modifiers.errorToThrow, retryAfterInMs = modifiers.retryAfterInMs, redirectTo = modifiers.redirectTo;

                if (!errorToThrow) {
                  _context.next = 51;
                  break;
                }

                strategyLogger.error("Retry ".concat(retryCount, ": Retry strategy ").concat(strategy.name, " throws error:"), errorToThrow);
                throw errorToThrow;

              case 51:
                if (!(retryAfterInMs || retryAfterInMs === 0)) {
                  _context.next = 56;
                  break;
                }

                strategyLogger.info("Retry ".concat(retryCount, ": Retry strategy ").concat(strategy.name, " retries after ").concat(retryAfterInMs));
                _context.next = 55;
                return delay(retryAfterInMs, undefined, {
                  abortSignal: request.abortSignal
                });

              case 55:
                return _context.abrupt("continue", 1);

              case 56:
                if (!redirectTo) {
                  _context.next = 60;
                  break;
                }

                strategyLogger.info("Retry ".concat(retryCount, ": Retry strategy ").concat(strategy.name, " redirects to ").concat(redirectTo));
                request.url = redirectTo;
                return _context.abrupt("continue", 1);

              case 60:
                _context.next = 39;
                break;

              case 62:
                _context.next = 67;
                break;

              case 64:
                _context.prev = 64;
                _context.t1 = _context["catch"](37);

                _iterator.e(_context.t1);

              case 67:
                _context.prev = 67;

                _iterator.f();

                return _context.finish(67);

              case 70:
                if (!responseError) {
                  _context.next = 73;
                  break;
                }

                logger.info("None of the retry strategies could work with the received error. Throwing it.");
                throw responseError;

              case 73:
                if (!response) {
                  _context.next = 76;
                  break;
                }

                logger.info("None of the retry strategies could work with the received response. Returning it.");
                return _context.abrupt("return", response);

              case 76:
                _context.next = 1;
                break;

              case 78:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 13], [37, 64, 67, 70]]);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}